
import BlogList from '~/components/blog/BlogList.vue';
import BlogListPreviewItem from '~/components/blog/BlogListPreviewItem.vue';
import IconArrowDown from '~/components/icons/IconArrowDown.vue';
import bloginfo from '~/helpers/bloginfo.js';

export default {
  components: { IconArrowDown, BlogList, BlogListPreviewItem },
  data () {
    return {
      eoc: bloginfo[0],
      comecloser: bloginfo[1],
      ufscommunity: bloginfo[3],
      sus: bloginfo[4],
      generationz: bloginfo[5],
      hamcollection: bloginfo[6],
      designFurniture: bloginfo[7]
    };
  }
};
